/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free HPLC method transfer calculator. Scale flow rate, injection volume and gradient time when moving a method between columns of different dimensions.`)
};

const es_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de transferencia de métodos HPLC gratuita. Escala el caudal, el volumen de inyección y el tiempo de gradiente al pasar un método entre columnas de distintas dimensiones.`)
};

const de_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser HPLC-Methodentransfer-Rechner. Skalieren Sie Flussrate, Injektionsvolumen und Gradientenzeit beim Übertragen einer Methode auf Säulen anderer Dimensionen.`)
};

const nl_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis HPLC-methodetransfercalculator. Schaal flowsnelheid, injectievolume en gradiënttijd bij het overzetten van een methode tussen kolommen met verschillende afmetingen.`)
};

const fr_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de transfert de méthode HPLC gratuit. Adaptez le débit, le volume d'injection et le temps de gradient lors du transfert d'une méthode entre colonnes de dimensions différentes.`)
};

const it_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito per il trasferimento di metodo HPLC. Scala portata, volume di iniezione e tempo di gradiente quando sposti un metodo tra colonne di dimensioni diverse.`)
};

const pt_br2_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de transferência de método de HPLC. Dimensione a vazão, o volume de injeção e o tempo de gradiente ao mudar um método entre colunas de dimensões diferentes.`)
};

const pt_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de transferência de método de HPLC gratuita. Escale o caudal, o volume de injeção e o tempo de gradiente ao transferir um método entre colunas de dimensões diferentes.`)
};

const ja_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のHPLCメソッド移行計算機です。異なる寸法のカラム間でメソッドを移行する際に、流速、注入量、グラジエント時間をスケーリングします。`)
};

const zh_hplc_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费 HPLC 方法转移计算器。在不同尺寸色谱柱之间转移方法时，换算流速、进样量和梯度时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_meta_description", locale)
	if (locale === "en") return en_hplc_meta_description(inputs)
	if (locale === "es") return es_hplc_meta_description(inputs)
	if (locale === "de") return de_hplc_meta_description(inputs)
	if (locale === "nl") return nl_hplc_meta_description(inputs)
	if (locale === "fr") return fr_hplc_meta_description(inputs)
	if (locale === "it") return it_hplc_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_meta_description(inputs)
	if (locale === "pt") return pt_hplc_meta_description(inputs)
	if (locale === "ja") return ja_hplc_meta_description(inputs)
	return zh_hplc_meta_description(inputs)
};